(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("jetblack-graphql-reconnect-client", [], factory);
	else if(typeof exports === 'object')
		exports["jetblack-graphql-reconnect-client"] = factory();
	else
		root["jetblack-graphql-reconnect-client"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition